<ng-container [ngSwitch]="item!.type">
  <span *ngSwitchDefault>
    {{ item!.value }}
  </span>

  <span *ngSwitchCase="itemType.Money">
    {{ item!.value | curr }}
  </span>

  <span *ngSwitchCase="itemType.Date">
    {{ item!.value | date }}
  </span>

  <span *ngSwitchCase="itemType.StrictValue">
    {{ setStrictValue(item!) }}
  </span>
</ng-container>
